import { minimize_str } from "@core/helpers/string";

export const ADD_BLOG_TO_FAVORITES = minimize_str(`
    mutation ($blog_id: ID, $is_favorite: Boolean) {
     result: addToFavoritesBlog(blog_id: $blog_id, is_favorite: $is_favorite) {
        success
      }
    }
  `);